import { render, staticRenderFns } from "./ProcessFour.vue?vue&type=template&id=194cb3b3"
import script from "./js/ProcessFour.js?vue&type=script&lang=js&external"
export * from "./js/ProcessFour.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports